import React from "react";
import Rollbar from '../utils/RollbarTracking'
import axios from 'axios'
import { toast } from 'react-toastify';
import Form from 'react-bootstrap/Form'
import Select from 'react-select';
import EasyEdit, { Types } from "react-easy-edit";
import FontAwesomeIcon from "react-fontawesome";

export class CustomersView extends React.Component {

  constructor(props)  {
      super(props);
      this.handleChange = this.handleChange.bind(this);
      this.handleChange2 = this.handleChange2.bind(this);
      this.handleChangeSelect = this.handleChangeSelect.bind(this);
      this.handleChangeSelect2 = this.handleChangeSelect2.bind(this);
  }

  state = {
      myCustomerData: [],
      deliveryDays: [],
      monday: false,
      tuesday: false,
      wednesday: false,
      thursday: false,
      friday: false,
      saturday: false,
      sunday: false,
      priceLists: [],
      selectedPriceList: {},
      catalogues: [],
      selectedCatalogue: {},
      paymentTermsOption: '',
      paymentTermsValue: '',
      alias: ''
  }

  handleChange(evt) {
    this.setState({ [evt.target.id]: evt.target.checked });
  }

  handleChange2(evt) {
    this.setState({ [evt.target.name]: evt.target.value });
  }

  handleChangeSelect(obj) {
    this.setState({ selectedPriceList: obj });
  }

  handleChangeSelect2(obj) {
    this.setState({ selectedCatalogue: obj });
  }

  componentWillMount() {
    this.fetchCustomerData();
    this.fetchPriceLists();
    this.fetchCatalogues();
  }

  updateDeliveryDays() {
    let arr = [];
    if(this.state.monday) { arr.push("Monday") }
    if(this.state.tuesday) { arr.push("Tuesday") }
    if(this.state.wednesday) { arr.push("Wednesday") }
    if(this.state.thursday) { arr.push("Thursday") }
    if(this.state.friday) { arr.push("Friday") }
    if(this.state.saturday) { arr.push("Saturday") }
    if(this.state.sunday) { arr.push("Sunday") }
    return arr;
  }

  dayCheckboxWrapper() {
    let arr = this.state.deliveryDays
    if(arr.includes("Monday")) {this.setState({ monday: true }) }
    if(arr.includes("Tuesday")) {this.setState({ tuesday: true }) }
    if(arr.includes("Wednesday")) {this.setState({ wednesday: true }) }
    if(arr.includes("Thursday")) {this.setState({ thursday: true }) }
    if(arr.includes("Friday")) {this.setState({ friday: true }) }
    if(arr.includes("Saturday")) {this.setState({ saturday: true }) }
    if(arr.includes("Sunday")) {this.setState({ sunday: true }) }
  }

  fetchCustomerData = async () => {
    axios.get('/customers/' + this.props.match.params.id)
        .then(data => {
            var termsOption = ''
            var termsValue = ''
            if (data[0].paymentTerms) {
              termsOption = JSON.parse(data[0].paymentTerms).option
              termsValue = JSON.parse(data[0].paymentTerms).value
            }
            this.setState({
              myCustomerData: data[0],
              deliveryDays: data[0].deliveryDays,
              paymentTermsOption: termsOption,
              paymentTermsValue: termsValue,
              selectedPriceList: {priceListID: data[0].priceListID, priceListName: data[0].priceListName},
              selectedCatalogue: {catalogueID: data[0].catalogueID, catalogueName: data[0].catalogueName},
              alias: data[0].alias
            });
            this.dayCheckboxWrapper();
        })
        .catch (err => {
          console.error(err);
          Rollbar.error(err)
          toast.error('Failed to fetch customer details')
        })
  }

  fetchPriceLists = async () => {
    axios.get('/pricelists')
      .then(data => {
        data.unshift({priceListID: null, priceListName: 'None'})
        this.setState({
          priceLists: data
        });
      })
      .catch (err => {
        console.error(err);
        Rollbar.error(err)
        toast.error('Failed to fetch price lists')
      })
  }

  fetchCatalogues = async () => {
    axios.get('/catalogues')
      .then(data => {
        data.unshift({catalogueID: null, catalogueName: 'None'})
        this.setState({
          catalogues: data
        });
      })
      .catch (err => {
        console.error(err);
        Rollbar.error(err)
        toast.error('Failed to fetch catalogues')
      })
  }

  modifyCustomer = async () => {
    let newDeliveryDays = this.updateDeliveryDays();
    var paymentTerms = null
    if (this.state.paymentTermsOption) {
      paymentTerms = JSON.stringify({option: this.state.paymentTermsOption, value: this.state.paymentTermsValue})
    }
    let requestParams = {
      'customerID': this.state.myCustomerData.customerID,
      'deliveryDays': newDeliveryDays,
      'paymentTerms': paymentTerms,
      'priceListID': this.state.selectedPriceList.priceListID,
      'catalogueID': this.state.selectedCatalogue.catalogueID,
      'alias': this.state.alias
    }
    axios.post('/customers/deliverydays', requestParams)
        .then(data => {
          toast.success("Customer Details Saved!");
        })
        .catch (err => {
          console.error(err)
          Rollbar.error(err)
          toast.error('Failed to save customer details')
        })
  }

  updateCustomerCompanyName = async (name) => {
    let requestParams = {
      'customerID': this.state.myCustomerData.customerID,
      'companyName': name,
    }
    axios.post('/customers/update/name', requestParams)
        .then(data => {
          toast.success("Customer Details Saved!");
        })
        .catch (err => {
          console.error(err)
          Rollbar.error(err)
          toast.error('Failed to save customer details')
        })
  }
    render() {
        return (
          <div className="mar-bot-lg">
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-1 mb-3 border-bottom">
              <h1 className="h3">Edit Customer</h1>
            </div>
            <div className="row">
              <div className="col-sm-6">
                <div className="card">
                  <div className="card-header">
                    Customer Information
                  </div>
                  <div className="card-body">
                    <p><strong>Name: </strong>{this.state.myCustomerData.name}</p>
                    <p><strong>Company: </strong>
                      <EasyEdit
                        type={Types.TEXT}
                        value={this.state.myCustomerData.company}
                        onSave={this.updateCustomerCompanyName}
                        saveButtonLabel={<FontAwesomeIcon name='check' />}
                        cancelButtonLabel={<FontAwesomeIcon name='times' />}
                        displayComponent={<CustomInlineEditDisplay />}
                      />
                    </p>
                    <p><strong>Email: </strong>{this.state.myCustomerData.email}</p>
                    <p><strong>Phone: </strong>{this.state.myCustomerData.phone}</p>
                    <p><strong>Address: </strong>{this.state.myCustomerData.address}</p>
                  </div>
                </div>
              </div>
              <div className="col-sm-6">
                <div className="card">
                  <div className="card-header">
                    Settings
                    {this.state.myCustomerData.extID ? <h6 className="float-right mb-0"><span className="badge badge-warning">External</span></h6> : null}
                  </div>
                  <div className="card-body">
                    <h5>Delivery Days</h5>
                    <Form.Check 
                      custom
                      type={'checkbox'}
                      id={'monday'}
                      label={'Monday'}
                      checked={this.state.monday}
                      onChange={(e) => {this.handleChange(e)}}
                    />
                    <Form.Check 
                      custom
                      type={'checkbox'}
                      id={'tuesday'}
                      label={'Tuesday'}
                      checked={this.state.tuesday}
                      onChange={(e) => {this.handleChange(e)}}
                    />
                    <Form.Check 
                      custom
                      type={'checkbox'}
                      id={'wednesday'}
                      label={'Wednesday'}
                      checked={this.state.wednesday}
                      onChange={(e) => {this.handleChange(e)}}
                    />
                    <Form.Check 
                      custom
                      type={'checkbox'}
                      id={'thursday'}
                      label={'Thursday'}
                      checked={this.state.thursday}
                      onChange={(e) => {this.handleChange(e)}}
                    />
                    <Form.Check 
                      custom
                      type={'checkbox'}
                      id={'friday'}
                      label={'Friday'}
                      checked={this.state.friday}
                      onChange={(e) => {this.handleChange(e)}}
                    />
                    <Form.Check 
                      custom
                      type={'checkbox'}
                      id={'saturday'}
                      label={'Saturday'}
                      checked={this.state.saturday}
                      onChange={(e) => {this.handleChange(e)}}
                    />
                    <Form.Check 
                      custom
                      type={'checkbox'}
                      id={'sunday'}
                      label={'Sunday'}
                      checked={this.state.sunday}
                      onChange={(e) => {this.handleChange(e)}}
                    />
                    <small className="form-text text-muted">
                      Select the days that this customer is allowed to order for (receive deliveries).
                    </small>
                    <h5 className="mt-3">Price List</h5>
                    <Select
                      value={this.state.selectedPriceList}
                      onChange={this.handleChangeSelect}
                      options={this.state.priceLists}
                      getOptionLabel={(option)=>option.priceListName}
                      getOptionValue={(option)=>option.priceListID}
                    />
                    <small className="form-text text-muted">
                      Select 'None' for no price list selection, the default product base prices will be used.
                    </small>
                    <h5 className="mt-3">Catalogue</h5>
                    <Select
                      value={this.state.selectedCatalogue}
                      onChange={this.handleChangeSelect2}
                      options={this.state.catalogues}
                      getOptionLabel={(option)=>option.catalogueName}
                      getOptionValue={(option)=>option.catalogueID}
                    />
                    <small className="form-text text-muted">
                      Select 'None' for no catalogue selection, all available products will be shown.
                    </small>
                    <h5 className="mt-3">Payment Terms</h5>
                    <div className="form-group">
                      <div className="input-group">
                        <select className="custom-select" name="paymentTermsOption" value={this.state.paymentTermsOption} onChange={this.handleChange2} >
                          <option value=""></option>
                          <option value="CashOnDelivery">Cash on Delivery</option>
                          <option value="PrePaid">Prepaid</option>
                          <option value="InAGivenNumberOfDays">In a given number of days</option>
                          <option value="OnADayOfTheMonth">On a day of the month</option>
                          <option value="NumberOfDaysAfterEOM">Number of days after EOM</option>
                          <option value="DayOfMonthAfterEOM">Day of month after EOM</option>
                        </select>
                        {this.state.paymentTermsOption === 'InAGivenNumberOfDays' || this.state.paymentTermsOption === 'NumberOfDaysAfterEOM' ? 
                        <>
                          <input type="text" className="form-control" value={this.state.paymentTermsValue} onChange={this.handleChange2} name="paymentTermsValue" />
                          <div className="input-group-append">
                            <label className="input-group-text">Days</label>
                          </div> 
                        </>: null}
                        {this.state.paymentTermsOption === 'OnADayOfTheMonth' ? 
                          <input type="date" className="form-control" value={this.state.paymentTermsValue} onChange={this.handleChange2} name="paymentTermsValue" />
                        : null}
                      </div>
                      <small className="form-text text-muted">
                        If no value is set here, the default payment terms set in the supplier settings will be used. If using an accounting integration, the value here will be automatically updated from the accounting system
                      </small>
                    </div>
                    <h5 className="mt-3">Alias</h5>
                    <div className="form-group">
                      <input type="text" className="form-control" value={this.state.alias} onChange={this.handleChange2} name="alias" />
                      <small className="form-text text-muted">
                        If set, this will be used in generated reports.
                      </small>
                    </div>
                    <button type="button" onClick={this.modifyCustomer} className="btn btn-success btn-sm btn-block mt-3">Save</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
    }
}

const CustomInlineEditDisplay = props => {
  const val = props.value || "";
  return (
    <div>
      {val}
      <FontAwesomeIcon name='pencil' style={{paddingLeft:'6px'}}/>
    </div>
  );
};